// import React, { useState, useCallback, useMemo } from "react";
// import "./StudentDashboardBottom.css";
// import dashboardData from "./studentDashboardData.json";
// import StudentViewAllModal from "./StudentViewAllModal";

// const ACTIVITY_ICON_MAP = {
//   dpp:     <span style={{ fontSize: 15 }}>📘</span>,
//   test:    <span style={{ fontSize: 15 }}>📝</span>,
//   fee:     <span style={{ fontSize: 15 }}>💳</span>,
//   absent:  <span style={{ fontSize: 15 }}>⚠️</span>,
//   default: <span style={{ fontSize: 15 }}>🔔</span>,
// };

// const SUBJECT_COLOR_MAP = {
//   Physics:   "#FFD580", 
//   Chemistry: "#87CEFA",
//   Biology:   "#8acc8a", 
//   Botany:    "#90EE90", 
//   Zoology:   "#FFB6C1",
//   Maths:     "#DDA0DD",
//   Overall:   "#B0C4DE", 
// };

// const FALLBACK_COLORS = ["#c3b79d", "#5b8dee", "#27ae60", "#e05c5c", "#9b59b6", "#1a1a2e", "#16a3a3"];

// const SUBJECTS_ORDER = ["Physics", "Chemistry", "Botany", "Zoology", "Biology", "Maths", "Overall"];

// const PX_PER_LABEL    = 130; // fixed gap per test — chart fills available width, then scrolls past this
// const CHART_HEIGHT    = 360;
// const LEFT_AXIS_W     = 40;
// // const Y_TICK_STEP     = 5; 
// function getYTickStep(dataMin, dataMax) {
//   if (dataMax > 500) return 50;
//   if (dataMax > 200) return 25;
//   return 10;
// }

// // ─── Tooltip ──────────────────────────────────────────────────────────────────
// function Tooltip({ tooltip, series, labels }) {
//   if (!tooltip) return null;
//   const { x, y, index } = tooltip;
//   return (
//     <div style={{
//       position:     "fixed",
//       left:         x + 12,
//       top:          y - 10,
//       background:   "#1a1a2e",
//       color:        "#fff",
//       borderRadius: 10,
//       padding:      "10px 14px",
//       fontSize:     12,
//       pointerEvents:"none",
//       zIndex:       9999,
//       boxShadow:    "0 4px 20px rgba(0,0,0,0.25)",
//       minWidth:     150,
//     }}>
//       <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
//         {labels[index]?.name}
//         <span style={{ fontWeight: 400, fontSize: 11, color: "#9a9ab0", marginLeft: 6 }}>
//           {labels[index]?.date}
//         </span>
//       </div>
//       {series.map((s) => (
//         <div key={s.label} style={{
//           display: "flex", alignItems: "center", gap: 8, marginBottom: 4,
//         }}>
//           <span style={{
//             width: 10, height: 10, borderRadius: "50%",
//             background: s.color, display: "inline-block", flexShrink: 0,
//           }} />
//           <span style={{ color: "#c8c8d8", flex: 1 }}>{s.label}</span>
//           <span style={{ fontWeight: 700, color: "#fff" }}>
//             {s.data[index] ?? "—"}
//           </span>
//         </div>
//       ))}
//     </div>
//   );
// }

// // ─── useContainerWidth ─────────────────────────────────────────────────────────
// function useContainerWidth() {
//   const ref = React.useRef(null);
//   const [width, setWidth] = useState(0);
//   React.useEffect(() => {
//     if (!ref.current) return;
//     const ro = new ResizeObserver((entries) => {
//       for (const entry of entries) setWidth(entry.contentRect.width);
//     });
//     ro.observe(ref.current);
//     return () => ro.disconnect();
//   }, []);
//   return [ref, width];
// }

// // ─── LineChart ────────────────────────────────────────────────────────────────
// function LineChart({ series, labels, activeSeries, onSeriesClick }) {
//   const [tooltip, setTooltip] = useState(null);
//   const [paneRef, paneWidth] = useContainerWidth();

//   const PAD = { top: 20, right: 24, bottom: 56, left: LEFT_AXIS_W };
//   const H   = CHART_HEIGHT - PAD.top - PAD.bottom;

//   const allValues = series.flatMap((s) => s.data.filter((v) => v !== null && !isNaN(v)));
//   const dataMin = allValues.length ? Math.min(...allValues) : 0;
//   const dataMax = allValues.length ? Math.max(...allValues) : 10;

//   // const minV = Math.floor(dataMin / Y_TICK_STEP) * Y_TICK_STEP - Y_TICK_STEP;
//   // const maxV = Math.ceil(dataMax / Y_TICK_STEP) * Y_TICK_STEP + Y_TICK_STEP;
//   // const yScale = (v) => H - ((v - minV) / (maxV - minV)) * H;
//   // const yTicks = [];
//   // for (let t = minV; t <= maxV; t += Y_TICK_STEP) yTicks.push(t);

//   const yTickStep = getYTickStep(dataMin, dataMax);

//   const minV = Math.floor(dataMin / yTickStep) * yTickStep - yTickStep;
//   const maxV = Math.ceil(dataMax / yTickStep) * yTickStep + yTickStep;

//   const yScale = (v) => H - ((v - minV) / (maxV - minV)) * H;

//   const yTicks = [];
//   for (let t = minV; t <= maxV; t += yTickStep) yTicks.push(t);


//   const handleMouseEnter = useCallback((e, i) => {
//     setTooltip({ x: e.clientX, y: e.clientY, index: i });
//   }, []);
//   const handleMouseMove  = useCallback((e) => {
//     setTooltip((p) => p ? { ...p, x: e.clientX, y: e.clientY } : null);
//   }, []);
//   const handleMouseLeave = useCallback(() => setTooltip(null), []);

//   const renderGrid = (W) =>
//     yTicks.map((t) => (
//       <g key={t}>
//         <line
//           x1={0} y1={yScale(t)} x2={W} y2={yScale(t)}
//           stroke={t === 0 ? "#b0b0c8" : "#f0f0f6"}
//           strokeWidth={t === 0 ? 1.5 : 1}
//           strokeDasharray={t === 0 ? "4 3" : "0"}
//         />
//         <text x={-6} y={yScale(t) + 4} fontSize={10} fill="#b0b0c8" textAnchor="end">
//           {t}
//         </text>
//       </g>
//     ));

//   const renderXLabels = (xScale) =>
//     labels.map((l, i) => (
//       <g key={i}>
//         <text x={xScale(i)} y={H + 18} fontSize={9} fill="#1a1a2e"
//           textAnchor="middle" fontWeight={500}>{l.name}</text>
//         <text x={xScale(i)} y={H + 30} fontSize={8} fill="#9a9ab0"
//           textAnchor="middle">( {l.date} )</text>
//       </g>
//     ));

//   const renderLines = (xScale, toPath) =>
//     series.map((s) => {
//       const isActive = activeSeries === s.label;
//       const isDimmed = activeSeries !== null && !isActive;
//       return (
//         <g key={s.label} style={{ cursor: "pointer" }}
//           onClick={() => onSeriesClick(s.label)}>
//           <path d={toPath(s.data)} fill="none" stroke="transparent" strokeWidth={14} />
//           <path
//             d={toPath(s.data)}
//             fill="none"
//             stroke={s.color}
//             strokeWidth={isActive ? 3 : 2}
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             opacity={isDimmed ? 0.15 : 1}
//             style={{ pointerEvents: "none" }}
//           />
//         </g>
//       );
//     });

//   const renderDots = (xScale) =>
//     series.map((s) => {
//       const isActive = activeSeries === s.label;
//       const isDimmed = activeSeries !== null && !isActive;
//       return s.data.map((v, i) => (
//         <circle
//           key={s.label + "-" + i}
//           cx={xScale(i)} cy={yScale(v)}
//           r={tooltip?.index === i && !isDimmed ? 6 : 4}
//           fill={s.color}
//           stroke="#fff"
//           strokeWidth={isActive ? 2 : 1.5}
//           opacity={isDimmed ? 0.1 : 1}
//           style={{ pointerEvents: "none" }}
//         />
//       ));
//     });

//   const renderHoverZones = (xScale, colW, totalH) =>
//     labels.map((_, i) => (
//       <rect
//         key={"hz-" + i}
//         x={xScale(i) - colW / 2} y={-PAD.top}
//         width={colW} height={totalH + PAD.top}
//         fill="transparent"
//         style={{ cursor: "crosshair" }}
//         onMouseEnter={(e) => handleMouseEnter(e, i)}
//         onMouseMove={handleMouseMove}
//         onMouseLeave={handleMouseLeave}
//       />
//     ));

//   const SIDE_PAD = 20;
//   const naturalW = labels.length * PX_PER_LABEL;
//   const totalW   = Math.max(naturalW, paneWidth || 0);
//   const plotW    = totalW - SIDE_PAD * 2;
//   const xScale   = (i) => SIDE_PAD + (i / Math.max(labels.length - 1, 1)) * plotW;
//   const toPath   = (data) =>
//     data
//       .map((v, i) => `${i === 0 ? "M" : "L"} ${xScale(i)} ${yScale(v)}`)
//       .join(" ");

//   return (
//     <>
//       <Tooltip tooltip={tooltip} series={series} labels={labels} />
//       <div style={{
//         display: "flex", flexDirection: "row",
//         width: "100%", minWidth: 0,
//         overflow: "hidden", height: CHART_HEIGHT,
//       }}>
//         <div style={{
//           width: LEFT_AXIS_W, minWidth: LEFT_AXIS_W,
//           flexShrink: 0, overflow: "hidden", height: CHART_HEIGHT,
//         }}>
//           <svg width={LEFT_AXIS_W} height={CHART_HEIGHT} style={{ display: "block" }}>
//             <g transform={`translate(${LEFT_AXIS_W},${PAD.top})`}>
//               {yTicks.map((t) => (
//                 <text key={t} x={-4} y={yScale(t) + 4}
//                   fontSize={10} fill="#b0b0c8" textAnchor="end">{t}</text>
//               ))}
//             </g>
//           </svg>
//         </div>

//         <div ref={paneRef} className="perf-trend-scroll-pane" style={{
//           flex: 1, minWidth: 0,
//           overflowX: "auto", overflowY: "hidden",
//           height: CHART_HEIGHT,
//         }}>
//           {paneWidth > 0 && (
//             <svg width={totalW} height={CHART_HEIGHT} style={{ display: "block" }}>
//               <g transform={`translate(0,${PAD.top})`}>
//                 {renderGrid(totalW)}
//                 {renderXLabels(xScale)}
//                 {renderHoverZones(xScale, plotW / Math.max(labels.length - 1, 1), H)}
//                 {renderLines(xScale, toPath)}
//                 {renderDots(xScale)}
//               </g>
//             </svg>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }

// // ─── Radial Dial ─────────────────────────────────────────────────────────────
// function RadialDial({ value, max = 100 }) {
//   const R = 30, CX = 40, CY = 40;
//   const circumference = 2 * Math.PI * R;
//   const dash = (value / max) * circumference;
//   return (
//     <svg className="exam-dial-svg" viewBox="0 0 80 80">
//       <circle cx={CX} cy={CY} r={R} fill="none" stroke="#f0f0f6" strokeWidth={8} />
//       <circle cx={CX} cy={CY} r={R} fill="none" stroke="#7c6fe0" strokeWidth={8}
//         strokeDasharray={`${dash} ${circumference - dash}`}
//         strokeLinecap="round" transform={`rotate(-90 ${CX} ${CY})`} />
//       <text x={CX} y={CY - 4} textAnchor="middle" fontSize={16} fontWeight={800} fill="#1a1a2e">{value}</text>
//       <text x={CX} y={CY + 10} textAnchor="middle" fontSize={9} fill="#9a9ab0" fontWeight={500}>/ 100</text>
//     </svg>
//   );
// }

// // ─── Transform progressCard → series + labels (dynamic, any subject set) ─────
// function transformProgressCard(progressCard = []) {
//   if (!progressCard.length) return { series: [], labels: [] };

//   const labels = progressCard.map((row) => ({
//     name: row.test_name ?? "—",
//     date: row.test_date
//       ? new Date(row.test_date).toLocaleDateString("en-GB", {
//           day: "2-digit", month: "short",
//         })
//       : "—",
//   }));

//   const keysInRow = new Set();
//   progressCard.forEach((row) => {
//     Object.keys(row).forEach((k) => {
//       if (k.endsWith("_total_marks")) keysInRow.add(k.replace(/_total_marks$/, ""));
//     });
//   });

//   const orderedKnown = SUBJECTS_ORDER.filter((s) => keysInRow.has(s));
//   const extras       = [...keysInRow].filter((s) => !SUBJECTS_ORDER.includes(s));
//   const activeSubs   = [...orderedKnown, ...extras].filter((s) =>
//     progressCard.some((row) => row[`${s}_total_marks`] !== null && row[`${s}_total_marks`] !== undefined)
//   );

//   const series = activeSubs.map((s, idx) => ({
//     label: s,
//     color: SUBJECT_COLOR_MAP[s] ?? FALLBACK_COLORS[idx % FALLBACK_COLORS.length],
//     data:  progressCard.map((row) => row[`${s}_total_marks`] ?? 0),
//   }));

//   return { series, labels };
// }

// // ─── Transform recentActivity → UI shape, normalized to "MMM DD, YYYY" ─
// function parseActivityDate(str) {
//   if (!str) return 0;
//   if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
//     const d = new Date(str + "T00:00:00");
//     return isNaN(d.getTime()) ? 0 : d.getTime();
//   }
//   const d = new Date(str.replace(/,/g, ""));
//   return isNaN(d.getTime()) ? 0 : d.getTime();
// }

// function formatActivityDate(str) {
//   const ts = parseActivityDate(str);
//   if (!ts) return str || "—";
//   const d = new Date(ts);
//   return d.toLocaleDateString("en-US", {
//     month: "short", day: "2-digit", year: "numeric",
//   }); // "Nov 05, 2025"
// }

// // ── UPDATED: now also keeps the raw activity_type from the API (rawType),
// // so we can build a filter dropdown straight off real API values, separate
// // from the normalized icon "type" (dpp/test/fee/absent/default). ──
// function transformRecentActivity(recentActivity = []) {
//   return [...recentActivity]
//     .sort((a, b) => parseActivityDate(b.activity_date) - parseActivityDate(a.activity_date))
//     .map((item) => {
//       const type = item.activity_type?.includes("DPP")
//         ? "dpp"
//         : item.activity_type === "ABSENT"
//         ? "absent"
//         : item.activity_type === "TEST"
//         ? "test"
//         : item.activity_type === "FEE"
//         ? "fee"
//         : "default";
//       const name = item.activity_name?.trim();
//       return {
//         type,
//         rawType: item.activity_type ?? "OTHER",   // ← raw API value, used for dropdown filtering
//         text: name || item.activity_type,
//         date: formatActivityDate(item.activity_date),
//       };
//     });
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function StudentDashboardBottom({ progressCard = [], recentActivity = [] }) {
//   const { examReadiness } = dashboardData;
//   const [activeSeries, setActiveSeries] = useState(null);
//   const [activityModalOpen, setActivityModalOpen] = useState(false);

//   // ── NEW: selected activity type for the dropdown filter ──
//   const [selectedActivityType, setSelectedActivityType] = useState("all");

//   const handleSeriesToggle = (label) =>
//     setActiveSeries((prev) => (prev === label ? null : label));

//   const { series: liveSeries, labels: liveLabels } = useMemo(
//     () => transformProgressCard(progressCard),
//     [progressCard]
//   );

//   const liveActivity = useMemo(
//     () => transformRecentActivity(recentActivity),
//     [recentActivity]
//   );

//   // ── NEW: unique activity_type values, built straight from the API data ──
//   const activityTypeList = useMemo(() => {
//     const seen = new Set();
//     const list = [];
//     liveActivity.forEach((item) => {
//       if (item.rawType && !seen.has(item.rawType)) {
//         seen.add(item.rawType);
//         list.push(item.rawType);
//       }
//     });
//     return list;
//   }, [liveActivity]);

//   // ── NEW: activity list filtered by the selected dropdown value ──
//   const filteredActivity = useMemo(() => {
//     if (selectedActivityType === "all") return liveActivity;
//     return liveActivity.filter((item) => item.rawType === selectedActivityType);
//   }, [liveActivity, selectedActivityType]);

//   const leftColRef = React.useRef(null);
//   const [leftColHeight, setLeftColHeight] = useState(null);

//   React.useEffect(() => {
//     if (!leftColRef.current) return;
//     const ro = new ResizeObserver((entries) => {
//       for (const entry of entries) setLeftColHeight(entry.contentRect.height);
//     });
//     ro.observe(leftColRef.current);
//     return () => ro.disconnect();
//   }, []);

//   return (
//     <div className="student-dashboard-bottom">
//       {/* ── Left column ── */}
//       <div ref={leftColRef} style={{ display: "flex", flexDirection: "column", gap: 16 }}>

//         {/* Performance Trends */}
//         <div className="dash-card perf-trends-card">
//           <div style={{
//             display: "flex", justifyContent: "space-between",
//             alignItems: "flex-start", flexWrap: "wrap",
//             gap: 8, marginBottom: 4,
//           }}>
//             <div>
//               <h3 className="dash-card-title">Performance Trends</h3>
//               <p className="dash-card-subtitle" style={{ marginBottom: 0 }}>
//                 Subject-wise score comparison
//               </p>
//             </div>

//             <div className="perf-legend">
//               {liveSeries.map((s) => {
//                 const isActive = activeSeries === s.label;
//                 const isDimmed = activeSeries !== null && !isActive;
//                 return (
//                   <span
//                     key={s.label}
//                     className="perf-legend-item"
//                     onClick={() => handleSeriesToggle(s.label)}
//                     style={{
//                       cursor: "pointer",
//                       opacity: isDimmed ? 0.3 : 1,
//                       transition: "opacity 0.2s",
//                       userSelect: "none",
//                       borderRadius: 6,
//                       padding: "2px 6px",
//                     }}
//                   >
//                     <span
//                       className="perf-legend-dot"
//                       style={{ background: s.color }}
//                     />
//                     {s.label}
//                   </span>
//                 );
//               })}
//             </div>
//           </div>

//           <div style={{ width: "100%", overflow: "hidden" }}>
//             {liveSeries.length > 0 ? (
//               <LineChart
//                 series={liveSeries}
//                 labels={liveLabels}
//                 activeSeries={activeSeries}
//                 onSeriesClick={handleSeriesToggle}
//               />
//             ) : (
//               <p style={{ color: "#9a9ab0", padding: 24 }}>
//                 No performance data available
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Exam Readiness */}
//         <div className="dash-card">
//           <h3 className="dash-card-title">Exam Readiness</h3>
//           <p className="dash-card-subtitle">Based on recent test scores</p>
//           <div className="exam-readiness-body">
//             <div className="exam-dial-wrap" />
//             <div className="exam-subjects">
//               {examReadiness.subjects.map((s) => {
//                 const color = SUBJECT_COLOR_MAP[s.name] ?? "#9a9ab0";
//                 return (
//                   <div key={s.name} className="exam-subject-row">
//                     <div className="exam-subject-meta">
//                       <span className="exam-subject-name">{s.name}</span>
//                       <span className="exam-subject-pct" style={{ color }}>
//                         {s.pct}%
//                       </span>
//                     </div>
//                     <div className="exam-bar-track">
//                       <div
//                         className="exam-bar-fill"
//                         style={{ width: `${s.pct}%`, background: color }}
//                       />
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Right column ── */}
//       {/* <div
//         className="student-dashboard-right"
//         style={leftColHeight ? { height: leftColHeight } : undefined}
//       > */}
//       <div className="student-dashboard-right" style={{ height: leftColHeight || 500 }} >
//         <div className="dash-card recent-activity-card">
//           <div className="recent-activity-header">
//             <h3 className="dash-card-title" style={{ marginBottom: 0 }}>
//               Recent Activity
//             </h3>

//             {/* ── NEW: type filter dropdown + View all, grouped together ── */}
//             <div style={{ display: "flex", alignItems: "center", gap: 10}}>
//               <select
//                 className="activity-filter-select"
//                 value={selectedActivityType}
//                 onChange={(e) => setSelectedActivityType(e.target.value)}
//               >
//                 <option value="all">All</option>
//                 {activityTypeList.map((t) => (
//                   <option key={t} value={t}>{t}</option>
//                 ))}
//               </select>

//               <button
//                 className="recent-activity-view-all"
//                 onClick={() => setActivityModalOpen(true)}
//               >
//                 View all
//               </button>
//             </div>
//           </div>

//           <div className="activity-list">
//             {filteredActivity.length > 0 ? (
//               filteredActivity.map((item, idx) => (
//                 <div key={idx} className="activity-item">
//                   <div className={`activity-icon-wrap act-${item.type}`}>
//                     {ACTIVITY_ICON_MAP[item.type] ?? ACTIVITY_ICON_MAP.default}
//                   </div>
//                   <span className="activity-text">{item.text}</span>
//                   <span className="activity-date">{item.date}</span>
//                 </div>
//               ))
//             ) : (
//               <p style={{ color: "#9a9ab0", padding: "8px 0" }}>No recent activity</p>
//             )}
//             <StudentViewAllModal
//               isOpen={activityModalOpen}
//               onClose={() => setActivityModalOpen(false)}
//               title="Recent Activity"
//               type="activity"
//               data={filteredActivity.map((item) => ({
//                 label:        item.text,
//                 display_date: item.date,
//                 type:         item.type,
//               }))}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useState, useCallback, useMemo } from "react";
import "./StudentDashboardBottom.css";
import dashboardData from "./studentDashboardData.json";
import StudentViewAllModal from "./StudentViewAllModal";

const ACTIVITY_ICON_MAP = {
  dpp:     <span style={{ fontSize: 15 }}>📘</span>,
  test:    <span style={{ fontSize: 15 }}>📝</span>,
  fee:     <span style={{ fontSize: 15 }}>💳</span>,
  absent:  <span style={{ fontSize: 15 }}>⚠️</span>,
  default: <span style={{ fontSize: 15 }}>🔔</span>,
};

const SUBJECT_COLOR_MAP = {
  Physics:   "#FFD580",
  Chemistry: "#87CEFA",
  Biology:   "#8acc8a",
  Botany:    "#90EE90",
  Zoology:   "#FFB6C1",
  Maths:     "#DDA0DD",
  Overall:   "#B0C4DE",
};

const FALLBACK_COLORS = ["#c3b79d", "#5b8dee", "#27ae60", "#e05c5c", "#9b59b6", "#1a1a2e", "#16a3a3"];

const SUBJECTS_ORDER = ["Physics", "Chemistry", "Botany", "Zoology", "Biology", "Maths", "Overall"];

const PX_PER_LABEL = 130;
const CHART_HEIGHT = 360;
const LEFT_AXIS_W  = 40;

function getYTickStep(dataMin, dataMax) {
  if (dataMax > 500) return 50;
  if (dataMax > 200) return 25;
  return 10;
}

// ─── Tooltip ──────────────────────────────────────────────────────────────────
function Tooltip({ tooltip, series, labels }) {
  if (!tooltip) return null;
  const { x, y, index } = tooltip;
  return (
    <div style={{
      position:      "fixed",
      left:          x + 12,
      top:           y - 10,
      background:    "#1a1a2e",
      color:         "#fff",
      borderRadius:  10,
      padding:       "10px 14px",
      fontSize:      12,
      pointerEvents: "none",
      zIndex:        9999,
      boxShadow:     "0 4px 20px rgba(0,0,0,0.25)",
      minWidth:      150,
    }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
        {labels[index]?.name}
        <span style={{ fontWeight: 400, fontSize: 11, color: "#9a9ab0", marginLeft: 6 }}>
          {labels[index]?.date}
        </span>
      </div>
      {series.map((s) => (
        <div key={s.label} style={{
          display: "flex", alignItems: "center", gap: 8, marginBottom: 4,
        }}>
          <span style={{
            width: 10, height: 10, borderRadius: "50%",
            background: s.color, display: "inline-block", flexShrink: 0,
          }} />
          <span style={{ color: "#c8c8d8", flex: 1 }}>{s.label}</span>
          <span style={{ fontWeight: 700, color: "#fff" }}>
            {s.data[index] ?? "Ab"}
          </span>
        </div>
      ))}
    </div>
  );
}

// ─── useContainerWidth ────────────────────────────────────────────────────────
function useContainerWidth() {
  const ref = React.useRef(null);
  const [width, setWidth] = useState(0);
  React.useEffect(() => {
    if (!ref.current) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) setWidth(entry.contentRect.width);
    });
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return [ref, width];
}

// ─── LineChart ────────────────────────────────────────────────────────────────
function LineChart({ series, labels, activeSeries, onSeriesClick }) {
  const [tooltip, setTooltip] = useState(null);
  const [paneRef, paneWidth]  = useContainerWidth();

  const PAD = { top: 20, right: 24, bottom: 56, left: LEFT_AXIS_W };
  const H   = CHART_HEIGHT - PAD.top - PAD.bottom;

  const allValues = series.flatMap((s) =>
    s.data.filter((v) => v !== null && v !== undefined && !isNaN(v))
  );
  const dataMin = allValues.length ? Math.min(...allValues) : 0;
  const dataMax = allValues.length ? Math.max(...allValues) : 10;

  const yTickStep = getYTickStep(dataMin, dataMax);
  // const minV      = Math.floor(dataMin / yTickStep) * yTickStep - yTickStep;
  const minV      = dataMin < 0 ? Math.floor(dataMin / yTickStep) * yTickStep : 0;
  const maxV      = Math.ceil(dataMax  / yTickStep) * yTickStep + yTickStep;
  const yScale    = (v) => H - ((v - minV) / (maxV - minV)) * H;

  const yTicks = [];
  for (let t = minV; t <= maxV; t += yTickStep) yTicks.push(t);

  const handleMouseEnter = useCallback((e, i) => {
    setTooltip({ x: e.clientX, y: e.clientY, index: i });
  }, []);
  const handleMouseMove  = useCallback((e) => {
    setTooltip((p) => p ? { ...p, x: e.clientX, y: e.clientY } : null);
  }, []);
  const handleMouseLeave = useCallback(() => setTooltip(null), []);

  // ── path that lifts the pen on null values (Ab / absent) ──
  const toPath = (data) => {
    let path    = "";
    let started = false;
    data.forEach((v, i) => {
      if (v === null || v === undefined) return; // skip point but DON'T reset started
      path   += `${!started ? "M" : "L"} ${xScale(i)} ${yScale(v)} `;
      started = true;
    });
    return path.trim();
  };
  
  const renderGrid = (W) =>
    yTicks.map((t) => (
      <g key={t}>
        <line
          x1={0} y1={yScale(t)} x2={W} y2={yScale(t)}
          stroke={t === 0 ? "#b0b0c8" : "#f0f0f6"}
          strokeWidth={t === 0 ? 1.5 : 1}
          strokeDasharray={t === 0 ? "4 3" : "0"}
        />
        <text x={-6} y={yScale(t) + 4} fontSize={10} fill="#b0b0c8" textAnchor="end">
          {t}
        </text>
      </g>
    ));

  const renderXLabels = (xScale) =>
    labels.map((l, i) => (
      <g key={i}>
        <text x={xScale(i)} y={H + 18} fontSize={9} fill="#1a1a2e"
          textAnchor="middle" fontWeight={500}>{l.name}</text>
        <text x={xScale(i)} y={H + 30} fontSize={8} fill="#9a9ab0"
          textAnchor="middle">( {l.date} )</text>
      </g>
    ));

  const renderLines = (xScale, toPath) =>
    series.map((s) => {
      const isActive = activeSeries === s.label;
      const isDimmed = activeSeries !== null && !isActive;
      return (
        <g key={s.label} style={{ cursor: "pointer" }}
          onClick={() => onSeriesClick(s.label)}>
          <path d={toPath(s.data)} fill="none" stroke="transparent" strokeWidth={14} />
          <path
            d={toPath(s.data)}
            fill="none"
            stroke={s.color}
            strokeWidth={isActive ? 3 : 2}
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={isDimmed ? 0.15 : 1}
            style={{ pointerEvents: "none" }}
          />
        </g>
      );
    });

  const renderDots = (xScale) =>
    series.map((s) => {
      const isActive = activeSeries === s.label;
      const isDimmed = activeSeries !== null && !isActive;
      return s.data.map((v, i) => {
        // skip null (Ab) points — no dot rendered
        if (v === null || v === undefined) return null;
        return (
          <circle
            key={s.label + "-" + i}
            cx={xScale(i)} cy={yScale(v)}
            r={tooltip?.index === i && !isDimmed ? 6 : 4}
            fill={s.color}
            stroke="#fff"
            strokeWidth={isActive ? 2 : 1.5}
            opacity={isDimmed ? 0.1 : 1}
            style={{ pointerEvents: "none" }}
          />
        );
      });
    });

  const renderHoverZones = (xScale, colW, totalH) =>
    labels.map((_, i) => (
      <rect
        key={"hz-" + i}
        x={xScale(i) - colW / 2} y={-PAD.top}
        width={colW} height={totalH + PAD.top}
        fill="transparent"
        style={{ cursor: "crosshair" }}
        onMouseEnter={(e) => handleMouseEnter(e, i)}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      />
    ));

  // const renderAbsentLines = (xScale) =>
  //   labels.map((_, i) => {
  //     const allAbsent = series.every(
  //       (s) => s.data[i] === null || s.data[i] === undefined
  //     );
  //     if (!allAbsent) return null;
  //     return (
  //       <line
  //         key={"absent-vline-" + i}
  //         x1={xScale(i)} y1={-PAD.top}
  //         x2={xScale(i)} y2={H}
  //         stroke="#e05c5c"
  //         strokeWidth={1.5}
  //         strokeDasharray="5 3"
  //         opacity={0.5}
  //       />
  //     );
  //   });


// REPLACE the entire renderAbsentLines function with:
// const renderAbsentBands = (xScale, colW) =>
//   labels.map((_, i) => {
//     const allAbsent = series.every(
//       (s) => s.data[i] === null || s.data[i] === undefined
//     );
//     if (!allAbsent) return null;
//     const halfW = colW / 2;
//     return (
//       <rect
//         key={"absent-band-" + i}
//         x={xScale(i) - halfW}
//         y={-PAD.top}
//         width={halfW * 2}
//         height={H + PAD.top}
//         fill="rgba(224, 92, 92, 0.12)"
//         rx={2}
//       />
//     );
//   });

 // REPLACE entire renderAbsentBands function with:
  const renderAbsentBands = (xScale, colW) =>
    labels.map((l, i) => {
      const allAbsent = series.every(
        (s) => s.data[i] === null || s.data[i] === undefined
      );
      if (!allAbsent) return null;
      // const halfW = colW / 2;
      const GAP  = 8;
      const prev = i > 0 ? xScale(i - 1) : xScale(i) - (xScale(1) - xScale(0));
      const next = i < labels.length - 1 ? xScale(i + 1) : xScale(i) + (xScale(labels.length - 1) - xScale(labels.length - 2));
      const halfW = Math.min(
        (xScale(i) - prev) / 2,
        (next - xScale(i)) / 2
      ) - GAP;

      const cx    = xScale(i);
      return (
        <g key={"absent-band-" + i}>
          <rect
            x={cx - halfW}
            y={-PAD.top}
            width={halfW * 2}
            height={H + PAD.top}
            fill="rgba(224, 92, 92, 0.12)"
            rx={2}
          />
        <text
            x={cx}
            y={(-PAD.top + H) / 2}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={11}
            fontWeight={600}
            fill="#e05c5c"
            opacity={0.8}
            transform={`rotate(-45, ${cx}, ${(-PAD.top + H) / 2})`}
            style={{ pointerEvents: "none", userSelect: "none" }}
          >
            ABSENT
          </text>
        </g>
      );
    });

  const SIDE_PAD = 20;
  const naturalW = labels.length * PX_PER_LABEL;
  const totalW   = Math.max(naturalW, paneWidth || 0);
  const plotW    = totalW - SIDE_PAD * 2;
  const xScale   = (i) => SIDE_PAD + (i / Math.max(labels.length - 1, 1)) * plotW;

  return (
    <>
      <Tooltip tooltip={tooltip} series={series} labels={labels} />
      <div style={{
        display: "flex", flexDirection: "row",
        width: "100%", minWidth: 0,
        overflow: "hidden", height: CHART_HEIGHT,
      }}>
        {/* fixed Y-axis */}
        <div style={{
          width: LEFT_AXIS_W, minWidth: LEFT_AXIS_W,
          flexShrink: 0, overflow: "hidden", height: CHART_HEIGHT,
        }}>
          <svg width={LEFT_AXIS_W} height={CHART_HEIGHT} style={{ display: "block" }}>
            <g transform={`translate(${LEFT_AXIS_W},${PAD.top})`}>
              {yTicks.map((t) => (
                <text key={t} x={-4} y={yScale(t) + 4}
                  fontSize={10} fill="#b0b0c8" textAnchor="end">{t}</text>
              ))}
            </g>
          </svg>
        </div>

        {/* scrollable plot pane */}
        <div ref={paneRef} className="perf-trend-scroll-pane" style={{
          flex: 1, minWidth: 0,
          overflowX: "auto", overflowY: "hidden",
          height: CHART_HEIGHT,
        }}>
          {paneWidth > 0 && (
            <svg width={totalW} height={CHART_HEIGHT} style={{ display: "block" }}>
              <g transform={`translate(0,${PAD.top})`}>
                {renderGrid(totalW)}
                {renderXLabels(xScale)}
                 {/* {renderAbsentLines(xScale)} */}
                 {renderAbsentBands(xScale, plotW / Math.max(labels.length - 1, 1))}
                {renderHoverZones(xScale, plotW / Math.max(labels.length - 1, 1), H)}
                {renderLines(xScale, toPath)}
                {renderDots(xScale)}
              </g>
            </svg>
          )}
        </div>
      </div>
    </>
  );
}

// ─── Radial Dial ──────────────────────────────────────────────────────────────
function RadialDial({ value, max = 100 }) {
  const R = 30, CX = 40, CY = 40;
  const circumference = 2 * Math.PI * R;
  const dash = (value / max) * circumference;
  return (
    <svg className="exam-dial-svg" viewBox="0 0 80 80">
      <circle cx={CX} cy={CY} r={R} fill="none" stroke="#f0f0f6" strokeWidth={8} />
      <circle cx={CX} cy={CY} r={R} fill="none" stroke="#7c6fe0" strokeWidth={8}
        strokeDasharray={`${dash} ${circumference - dash}`}
        strokeLinecap="round" transform={`rotate(-90 ${CX} ${CY})`} />
      <text x={CX} y={CY - 4} textAnchor="middle" fontSize={16} fontWeight={800} fill="#1a1a2e">{value}</text>
      <text x={CX} y={CY + 10} textAnchor="middle" fontSize={9} fill="#9a9ab0" fontWeight={500}>/ 100</text>
    </svg>
  );
}

// ─── transformProgressCard ────────────────────────────────────────────────────
function transformProgressCard(progressCard = []) {
  if (!progressCard.length) return { series: [], labels: [] };

  // sort oldest → newest so chart reads left-to-right chronologically
  const sorted = [...progressCard].sort(
    (a, b) => new Date(a.test_date) - new Date(b.test_date)
  );

  const labels = sorted.map((row) => ({
    name: row.test_name ?? "—",
    date: row.test_date
      ? new Date(row.test_date).toLocaleDateString("en-GB", {
          day: "2-digit", month: "short",
        })
      : "—",
  }));

  const keysInRow = new Set();
  sorted.forEach((row) => {
    Object.keys(row).forEach((k) => {
      if (k.endsWith("_total_marks")) keysInRow.add(k.replace(/_total_marks$/, ""));
    });
  });

  const orderedKnown = SUBJECTS_ORDER.filter((s) => keysInRow.has(s));
  const extras       = [...keysInRow].filter((s) => !SUBJECTS_ORDER.includes(s));

  // only include subjects that have at least one real numeric value
  const activeSubs = [...orderedKnown, ...extras].filter((s) =>
    sorted.some((row) => {
      const v = row[`${s}_total_marks`];
      return v !== null && v !== undefined && v !== "Ab";
    })
  );

  const series = activeSubs.map((s, idx) => ({
    label: s,
    color: SUBJECT_COLOR_MAP[s] ?? FALLBACK_COLORS[idx % FALLBACK_COLORS.length],
    data: sorted.map((row) => {
      const v = row[`${s}_total_marks`];
      // "Ab" / null / undefined → null so chart skips (no dot, no zero, line breaks)
      return v === "Ab" || v === null || v === undefined ? null : v;
    }),
  }));

  return { series, labels };
}

// ─── transformRecentActivity ──────────────────────────────────────────────────
function parseActivityDate(str) {
  if (!str) return 0;
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const d = new Date(str + "T00:00:00");
    return isNaN(d.getTime()) ? 0 : d.getTime();
  }
  const d = new Date(str.replace(/,/g, ""));
  return isNaN(d.getTime()) ? 0 : d.getTime();
}

function formatActivityDate(str) {
  const ts = parseActivityDate(str);
  if (!ts) return str || "—";
  const d = new Date(ts);
  return d.toLocaleDateString("en-US", {
    month: "short", day: "2-digit", year: "numeric",
  });
}

function transformRecentActivity(recentActivity = []) {
  return [...recentActivity]
    .sort((a, b) => {
      const dateA = a.activity_date ?? a.date ?? "";
      const dateB = b.activity_date ?? b.date ?? "";
      return parseActivityDate(dateB) - parseActivityDate(dateA);
    })
    .map((item) => {
      // support both API shape (activity_type) and JSON shape (type)
      const rawActivityType = item.activity_type ?? item.type?.toUpperCase() ?? "OTHER";
      const type = rawActivityType.includes("DPP")
        ? "dpp"
        : rawActivityType === "ABSENT"
        ? "absent"
        : rawActivityType === "TEST"
        ? "test"
        : rawActivityType === "FEE"
        ? "fee"
        : "default";
      const name    = (item.activity_name ?? item.text ?? "").trim();
      const dateStr =  item.activity_date  ?? item.date ?? "";
      return {
        type,
        rawType: rawActivityType,
        text:    name || rawActivityType,
        date:    formatActivityDate(dateStr),
      };
    });
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function StudentDashboardBottom({
  progressCard:    progressCardProp,
  recentActivity:  recentActivityProp,
}) {
  const { examReadiness, progress_card, recentActivity: jsonActivity } = dashboardData;

  // use prop if provided (API), otherwise fall back to JSON
  const progressCard   = progressCardProp?.length  ? progressCardProp  : (progress_card ?? []);
  const recentActivity = recentActivityProp?.length ? recentActivityProp : (jsonActivity  ?? []);

  const [activeSeries,        setActiveSeries]        = useState(null);
  const [activityModalOpen,   setActivityModalOpen]   = useState(false);
  const [selectedActivityType, setSelectedActivityType] = useState("all");

  const handleSeriesToggle = (label) =>
    setActiveSeries((prev) => (prev === label ? null : label));

  const { series: liveSeries, labels: liveLabels } = useMemo(
    () => transformProgressCard(progressCard),
    [progressCard]
  );

  const liveActivity = useMemo(
    () => transformRecentActivity(recentActivity),
    [recentActivity]
  );

  const activityTypeList = useMemo(() => {
    const seen = new Set();
    const list = [];
    liveActivity.forEach((item) => {
      if (item.rawType && !seen.has(item.rawType)) {
        seen.add(item.rawType);
        list.push(item.rawType);
      }
    });
    return list;
  }, [liveActivity]);

  const filteredActivity = useMemo(() => {
    if (selectedActivityType === "all") return liveActivity;
    return liveActivity.filter((item) => item.rawType === selectedActivityType);
  }, [liveActivity, selectedActivityType]);

  const leftColRef = React.useRef(null);
  const [leftColHeight, setLeftColHeight] = useState(null);

  React.useEffect(() => {
    if (!leftColRef.current) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) setLeftColHeight(entry.contentRect.height);
    });
    ro.observe(leftColRef.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="student-dashboard-bottom">
      {/* ── Left column ── */}
      <div ref={leftColRef} style={{ display: "flex", flexDirection: "column", gap: 16 }}>

        {/* Performance Trends */}
        <div className="dash-card perf-trends-card">
          <div style={{
            display: "flex", justifyContent: "space-between",
            alignItems: "flex-start", flexWrap: "wrap",
            gap: 8, marginBottom: 4,
          }}>
            <div>
              <h3 className="dash-card-title">Performance Trends</h3>
              <p className="dash-card-subtitle" style={{ marginBottom: 0 }}>
                Subject-wise score comparison
              </p>
            </div>

            <div className="perf-legend">
              {liveSeries.map((s) => {
                const isActive = activeSeries === s.label;
                const isDimmed = activeSeries !== null && !isActive;
                return (
                  <span
                    key={s.label}
                    className="perf-legend-item"
                    onClick={() => handleSeriesToggle(s.label)}
                    style={{
                      cursor:     "pointer",
                      opacity:    isDimmed ? 0.3 : 1,
                      transition: "opacity 0.2s",
                      userSelect: "none",
                      borderRadius: 6,
                      padding: "2px 6px",
                    }}
                  >
                    <span className="perf-legend-dot" style={{ background: s.color }} />
                    {s.label}
                  </span>
                );
              })}
            </div>
          </div>

          <div style={{ width: "100%", overflow: "hidden" }}>
            {liveSeries.length > 0 ? (
              <LineChart
                series={liveSeries}
                labels={liveLabels}
                activeSeries={activeSeries}
                onSeriesClick={handleSeriesToggle}
              />
            ) : (
              <p style={{ color: "#9a9ab0", padding: 24 }}>
                No performance data available
              </p>
            )}
          </div>
        </div>

        {/* Exam Readiness */}
        <div className="dash-card">
          <h3 className="dash-card-title">Exam Readiness</h3>
          <p className="dash-card-subtitle">Based on recent test scores</p>
          <div className="exam-readiness-body">
            <div className="exam-dial-wrap" />
            <div className="exam-subjects">
              {examReadiness.subjects.map((s) => {
                const color = SUBJECT_COLOR_MAP[s.name] ?? "#9a9ab0";
                return (
                  <div key={s.name} className="exam-subject-row">
                    <div className="exam-subject-meta">
                      <span className="exam-subject-name">{s.name}</span>
                      <span className="exam-subject-pct" style={{ color }}>{s.pct}%</span>
                    </div>
                    <div className="exam-bar-track">
                      <div
                        className="exam-bar-fill"
                        style={{ width: `${s.pct}%`, background: color }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* ── Right column ── */}
      <div className="student-dashboard-right" style={{ height: leftColHeight || 500 }}>
        <div className="dash-card recent-activity-card">
          <div className="recent-activity-header">
            <h3 className="dash-card-title" style={{ marginBottom: 0 }}>
              Recent Activity
            </h3>

            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <select
                className="activity-filter-select"
                value={selectedActivityType}
                onChange={(e) => setSelectedActivityType(e.target.value)}
              >
                <option value="all">All</option>
                {activityTypeList.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>

              <button
                className="recent-activity-view-all"
                onClick={() => setActivityModalOpen(true)}
              >
                View all
              </button>
            </div>
          </div>

          <div className="activity-list">
            {filteredActivity.length > 0 ? (
              filteredActivity.map((item, idx) => (
                <div key={idx} className="activity-item">
                  <div className={`activity-icon-wrap act-${item.type}`}>
                    {ACTIVITY_ICON_MAP[item.type] ?? ACTIVITY_ICON_MAP.default}
                  </div>
                  <span className="activity-text">{item.text}</span>
                  <span className="activity-date">{item.date}</span>
                </div>
              ))
            ) : (
              <p style={{ color: "#9a9ab0", padding: "8px 0" }}>No recent activity</p>
            )}
            <StudentViewAllModal
              isOpen={activityModalOpen}
              onClose={() => setActivityModalOpen(false)}
              title="Recent Activity"
              type="activity"
              data={filteredActivity.map((item) => ({
                label:        item.text,
                display_date: item.date,
                type:         item.type,
              }))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}